import { config } from '@app/config';

import type { CryptoProCertificate } from './types';

export * from './types';
export * from './hashAlgorithms';

// Реализация грузится лениво: пакет crypto-pro (и мок) не попадают в основной
// бандл, а выбор боевая/мок сделан в одной точке по флагу из config.
const loadImplementation = () =>
  config.isCryptoProMock ? import('./cryptoProMock') : import('./cryptoPro');

/** Плагин КриптоПро установлен и отвечает. Не бросает исключений. */
export const isPluginAvailable = async (): Promise<boolean> =>
  (await loadImplementation()).isPluginAvailable();

/** Действующие сертификаты пользователя с закрытым ключом. */
export const getCertificates = async (): Promise<CryptoProCertificate[]> =>
  (await loadImplementation()).getCertificates();

/**
 * Откреплённая CAdES-BES подпись готового хэша (HashHex/HashAlgorithm из
 * MedicalDocuments/GetHash). Возвращает base64 для поля SignatureData.
 */
export const signHash = async (
  thumbprint: string,
  hashHex: string,
  hashAlgorithmUrn: string
): Promise<string> =>
  (await loadImplementation()).signHash(thumbprint, hashHex, hashAlgorithmUrn);

/**
 * Откреплённая CAdES-BES подпись СОДЕРЖИМОГО документа (Base64 из
 * MedicalDocuments/GetDocumentXml). Плагин сам хэширует контент алгоритмом из
 * ключа сертификата, поэтому серверное ГОСТ-хэширование не требуется.
 * Возвращает base64 для поля SignatureData.
 */
export const signContent = async (
  thumbprint: string,
  contentBase64: string
): Promise<string> =>
  (await loadImplementation()).signContent(thumbprint, contentBase64);
